<template>

  <div class="animated fadeIn">
    <b-card no-body>
      <b-row>
        <b-col cols="10" class="ml-2">
          <h2>Selected Satsangi: {{getSatsangiName()}}</h2>
        </b-col>
        <b-col class="m-2" no-gutters>
          <b-button v-b-toggle.catsidebar class="ml-1" variant="info">Categories</b-button>
      </b-col>
      </b-row>
    </b-card>

    <b-row>
      <b-col>
        <sale-option-buttons @deleteLine="deleteProduct"
                             @newSale="newSale(true)"
                             @retrieveParkedSale="retrieveParkedSale"
                             @parkSale="parkSale"
                             @searchSatsangi="searchSatsangi"
                             @editLineItem="editSelectedProduct"
                             @payments="submitPayments"
                             @printReceipt="reprintReceipt"
                            />
      </b-col>
    </b-row>
    <b-card no-body>
      <b-row>
        <b-col>
          <sale-ticket-items
            :systemid="systemid"
            @processpayment="processPayment" @qtyChanged="qtyChanged" @product-by-barcode="productSelected"
            ref="ticketItemsTab"></sale-ticket-items>
        </b-col>
      </b-row>
      <b-row>
         <b-sidebar id="catsidebar" title="Categories and Products" shadow width="500px">
        <b-col>
          <category-product-panel :systemid="systemid" @productSelected="productSelected" @updated="setFocus"></category-product-panel>
        </b-col>
        </b-sidebar>
      </b-row>
    </b-card>
    <div>
      <b-modal ref="modalSearchSatsangi"
               title="Search Satsangi"
               hide-footer
               @hide="hideSearchSatsangiModal"
               no-enforce-focus
               no-close-on-backdrop
               centered
               size="lg">
        <search-satsangi-modal @success="searchSatsangiSuccess" @cancel="cancelSearchSatsangi" />
      </b-modal>
    </div>
    <div>
      <b-modal ref="modalVariablePriceQty"
               title="Variable Price and Quantity"
               hide-footer
               no-enforce-focus
               no-close-on-backdrop
               centered
               size="lg">
        <variable-prd-price-modal @success="acceptVariablePriceQty" @cancel="cancelVariablePriceQty" :product="editProduct" />
      </b-modal>
    </div>
  </div>

</template>
<script>

  import Vue from 'vue'
  import CategoryProductPanel from './CategoryProductPanel'
  import SaleTicketItems from './components/SaleTicketItems'
  import SaleOptionButtons from './components/SaleOptionButtons'
  import SearchSatsangiModal from './components/SearchSatsangiModal'
  import VariablePrdPriceModal from './components/VariablePrdPriceModal'
  import filter from 'lodash/filter'

  const receiptShape = {
    receiptType: "officeprasad",
    products: null,
    ticketid: null,
    cardno: null
  }

  export default {
    name: 'OfficePos',
    components: {
      'category-product-panel': CategoryProductPanel,
      'sale-ticket-items': SaleTicketItems,
      'sale-option-buttons': SaleOptionButtons,
      'search-satsangi-modal': SearchSatsangiModal,
      'variable-prd-price-modal': VariablePrdPriceModal
    },
    data: function() {
      return {
        selecetdSatsangi: null,
        editProduct: null,
        systemid: '1',
        showConfirmMsg: false,
        receipt: Object.assign({}, receiptShape),

      }
    },
    computed: {
      getBhaintCategories(){
        return filter(this.$store.state.pos.bhaintPrasadCategories,
           function(cat) {
             return (cat.isbhaint == true);
           });
      },
      getPrasadCategories(){
        return filter(this.$store.state.pos.bhaintPrasadCategories,
           function(cat) {
             return (cat.isprasad == true);
           });
      },
    },
    methods: {
      submitPayments(){
        if(this.$refs.ticketItemsTab.getLineItemsSize() > 0){
          this.$refs.ticketItemsTab.submitCash();
        }
        else {
          this.showErrorMsg({
            message:
              'Please select products for sale before clicking Payments option.'
          })
        }

      },
      acceptVariablePriceQty(product) {
        console.log(product)
        this.$refs.modalVariablePriceQty.hide()
        var selectedProduct = JSON.parse(JSON.stringify(product))
        if (this.checkCardScanned(selectedProduct, false)) {
          this.$refs.ticketItemsTab.priceQtyChanged(selectedProduct)
        }else{
          this.$refs.ticketItemsTab.priceQtyChanged(null);
        }
      },
      cancelVariablePriceQty() {
        this.$refs.modalVariablePriceQty.hide()
      },
      editSelectedProduct() {
        var productSelectedToEdited = this.$refs.ticketItemsTab.getProductToBeEdited()
        if (productSelectedToEdited != null) {
          this.editProduct = JSON.parse(JSON.stringify(productSelectedToEdited))
          this.$refs.modalVariablePriceQty.show()
        } else {
          this.showErrorMsg({
            message:
              'Please select the Transaction Line Item to change first. (बदलने के लिए कृपया पहले लेन-देन लाइन आइटम का चयन करें).'
          })
        }
      },
      getSatsangiName() {
        if (this.selecetdSatsangi != null && Object.keys(this.selecetdSatsangi).length > 0) {
          return this.selecetdSatsangi.name
        } else {
          return 'None'
        }
      },
      checkBhentOrPrasadCategory(catId, isBhent) {
        let categoriesId;
        if (isBhent) {
          // Todo: Get Bhent Category from backend. Hardcoded for now
          categoriesId = this.getBhaintCategories;

        } else {
          // Todo: Get Prasad Category from backend. Hardcoded for now
          categoriesId = this.getPrasadCategories;

        }

        var found = categoriesId.filter(function(item) {
          return item.categoryId == catId
        });

        return (found != null && found.length > 0);
      },
      checkCardScanned(product, isAddNew) {
        let hasCardLine = false
        let cardExists = false
        let hasBhentCat = false
        let hasSameProduct = false

        let totalPrasadPrice = 0
        let totalBhentAmount = 0
        if (
          product.categoryId != null &&
          isAddNew == true &&
          this.checkBhentOrPrasadCategory(product.categoryId, true) == true
        ) {
          if (this.selecetdSatsangi != null && Object.keys(this.selecetdSatsangi).length > 0) {
            hasCardLine = true
          }
          if (!hasCardLine) {
            this.showErrorMsg({
              message:
                'Please scan Satsangi Card before taking Bhaint (कृपया भेंट लेने से पहले सत्संगी का कॉर्ड स्कैन करें).'
            })
          }
        } else if (
          product.categoryId != null &&
          isAddNew == true &&
          this.checkBhentOrPrasadCategory(product.categoryId, false) == true
        ) {
          const selectedProducts = this.$refs.ticketItemsTab.getProductsSelected()

          if (selectedProducts != null) {
            let tempThis = this
            selectedProducts.forEach(function(prd) {
              if (tempThis.checkBhentOrPrasadCategory(prd.categoryId, true) == true) {
                totalBhentAmount = totalBhentAmount + prd.total
                hasBhentCat = true
              } else if (product.id != null && product.id === prd.id && prd.price == 0) {
                hasSameProduct = true
              } else if (tempThis.checkBhentOrPrasadCategory(prd.categoryId, false) == true && prd.price == 0) {
                totalPrasadPrice = totalPrasadPrice + prd.actualPrice * prd.qty
              }
            })
          }

          if (hasBhentCat == true) {
            var totalPriceWithNewProduct =
              totalPrasadPrice +
              (product.qty ? product.qty : 1) * (product.actualPrice ? product.actualPrice : product.price)
            if (totalPriceWithNewProduct <= totalBhentAmount && hasSameProduct == false) {
              product.price = 0
              this.showConfirmMsg = true;
              hasCardLine = true
            } else {
              hasCardLine = true
            }
          } else {
            hasCardLine = true
          }

          /* if(hasSameProduct){
                hasCardLine = true;
              }
              else {
                if(hasBhentCat == true){
                  var totalAmount = (product.qty ? product.qty : 1) * (product.actualPrice ? product.actualPrice : product.price);
                  if(totalAmount <= totalBhentAmount){
                    product.price = 0;
                    hasCardLine = true;
                  }
                  else{
                    hasCardLine = false;
                    this.$bvModal
                      .msgBoxConfirm("Total Prasad value against the Bhaint can not be greater than Bhaint. Do you want to Charge full Price instead (भेंट के सामने दी हुई प्रसाद की कुल कीमत भेंट से कम होनी चाहिये.क्या आप इसके बदले पूरी कीमत चार्ज करना चाहते हैं)?", {
                        title: "Please Confirm (कृपया पुष्टि करें)",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "danger",
                        okTitle: "YES",
                        cancelTitle: "NO",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true
                      })
                      .then(value => {
                        if (value == true) {
                         product.price = product.actualPrice;
                         this.$refs.ticketItemsTab.addProduct(product);
                         this.$refs.ticketItemsTab.setBarcodeInputFocus();
                        } else {
                           this.showErrorMsg({
                            message:
                              "Total Prasad value against the Bhaint can not be greater than Bhaint (भेंट के सामने दी हुई प्रसाद की कुल कीमत भेंट से कम होनी चाहिये)."
                            });
                        }

                      })
                      .catch(err => {
                        this.showErrorMsg({
                          message: err
                        });
                      });

                  }

                }
                else{
                    hasCardLine = true;
                }
              }*/
        } else if (isAddNew == false) {
          hasBhentCat = false
          hasSameProduct = false

          totalPrasadPrice = 0
          totalBhentAmount = 0
          if (this.checkBhentOrPrasadCategory(product.categoryId, true) == true) {
            const selectedProducts = this.$refs.ticketItemsTab.getProductsSelected()

            if (selectedProducts != null) {
              let tempThis = this
              selectedProducts.forEach(function(prd) {
                if (tempThis.checkBhentOrPrasadCategory(prd.categoryId, true) == true) {
                  //If being edited from modal of price and qty then get new price and qty instead.
                  if (prd.isEditing == true) {
                    totalBhentAmount = totalBhentAmount + product.actualPrice * product.qty
                  } else {
                    totalBhentAmount = totalBhentAmount + prd.actualPrice * prd.qty
                  }
                  hasBhentCat = true
                } else if (tempThis.checkBhentOrPrasadCategory(prd.categoryId, false) == true && prd.price == 0) {
                  totalPrasadPrice = totalPrasadPrice + prd.actualPrice * prd.qty
                }
              })
              console.log(totalBhentAmount)
              console.log(totalPrasadPrice)
              if (totalBhentAmount >= totalPrasadPrice) {
                hasCardLine = true
              } else {
                hasCardLine = false
                this.showErrorMsg({
                  message:
                    'Total Prasad value with 0 Totals against the Bhaint can not be greater than Bhaint (भंट के सामने, 0 टोटल के साथ कुल प्रसाद का मूल्य, भंट से अधिक नहीं हो सकता है).'
                })
              }
            }
          } else {
            if (this.checkBhentOrPrasadCategory(product.categoryId, false) == true) {
              const selectedProducts = this.$refs.ticketItemsTab.getProductsSelected()
              if (selectedProducts != null) {
                let tempThis = this
                selectedProducts.forEach(function(prd) {
                  if (tempThis.checkBhentOrPrasadCategory(prd.categoryId, true) == true) {
                    totalBhentAmount = totalBhentAmount + prd.actualPrice * prd.qty
                    hasBhentCat = true
                  } else if (tempThis.checkBhentOrPrasadCategory(prd.categoryId, false) == true && prd.price == 0) {
                    if (prd.isEditing == true) {
                      totalPrasadPrice = totalPrasadPrice + product.actualPrice * product.qty;
                    }
                    else{
                      totalPrasadPrice = totalPrasadPrice + prd.actualPrice * prd.qty;
                    }

                  }
                })
                if (totalBhentAmount >= totalPrasadPrice) {
                  hasCardLine = true
                } else {
                  this.showErrorMsg({
                    message:
                      'Total Prasad value with 0 Totals against the Bhaint can not be greater than Bhaint (भंट के सामने, 0 टोटल के साथ कुल प्रसाद का मूल्य, भंट से अधिक नहीं हो सकता है).'
                  })
                  hasCardLine = false
                }
              }
            } else {
              hasCardLine = true
            }
          }
        } else {
          hasCardLine = true
        }
        return hasCardLine
      },
      qtyChanged(productQtyIncrease) {
        if (this.checkCardScanned(productQtyIncrease.product, false)) {
          this.$refs.ticketItemsTab.changeProductQty(productQtyIncrease.index, true, productQtyIncrease.product.qty)
        } else {
          this.$refs.ticketItemsTab.changeProductQty(productQtyIncrease.index, false, productQtyIncrease.origQty)
        }
      },
      productSelected(product) {
        this.showConfirmMsg = false;
        if (this.checkCardScanned(product, true)) {
          if(this.showConfirmMsg){
            this.$bvModal
              .msgBoxConfirm('Does satsangi want Prasad against Bhaint?', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true,
                noCloseOnBackdrop: true,
                noCloseOnEsc:true
              })
              .then(value => {
                if (value == false) {
                  product.price = product.actualPrice;
                }
                this.$refs.ticketItemsTab.addProduct(product)
                this.$refs.ticketItemsTab.setBarcodeInputFocus()
              })
              .catch(err => {
                this.showErrorMsg({
                  message: err
                })
              })
          }
          else{
            this.$refs.ticketItemsTab.addProduct(product)
            this.$refs.ticketItemsTab.setBarcodeInputFocus()
          }

        }
      },
      deleteProduct() {
        var productSelectedToDelete = this.$refs.ticketItemsTab.getProductToBeDelete()
        if (
          productSelectedToDelete != null &&
          this.checkBhentOrPrasadCategory(productSelectedToDelete.categoryId, true) == true
        ) {
          var returnValue = this.checkProductAgainstBhaint()
          if (returnValue == false) {
            this.$refs.ticketItemsTab.deleteProduct()
            this.$refs.ticketItemsTab.setBarcodeInputFocus()
          }
        } else {
          this.$refs.ticketItemsTab.deleteProduct()
          this.$refs.ticketItemsTab.setBarcodeInputFocus()
        }
      },
      checkProductAgainstBhaint() {
        var returnValue = false
        const selectedProducts = this.$refs.ticketItemsTab.getProductsSelected()
        if (selectedProducts != null) {
          for (let i = 0; i < selectedProducts.length; i++) {
            var line = selectedProducts[i]
            if (this.checkBhentOrPrasadCategory(line.categoryId, false) == true && line.price == 0) {
              returnValue = true
              this.showErrorMsg({
                message:
                  'Please remove Prasad line items given against the Bhaint before removing/changing the Bhaint Item. (कृपया भेंट आइटम को हटाने से पहले भेंट के खिलाफ दिए गए प्रसाद लाइनों को हटा दें).'
              })
              break
            }
          }
        }

        return returnValue
      },
      newSale(showMsg) {
        this.$refs.ticketItemsTab.deleteAllProducts(showMsg);
        this.$refs.ticketItemsTab.setBarcodeInputFocus();
        this.selecetdSatsangi = null;

      },
      async reprintReceipt(){
        if(this.receipt == null || this.receipt.ticketid == null || this.receipt.products == null){
          this.showErrorMsg({
            message: "No last receipt to print."
          });
        }
        else{
          await this.callReceiptService();
        }

      },
      async printReceipt(data){

        this.receipt.receiptType = "officeprasad"
        this.receipt.products = data.products
        this.receipt.ticketid = data.ticketid
        this.receipt.cardno = data.cardno

        await this.callReceiptService();
      },
      callReceiptService(){
        this.$nextTick(() => {
         let params = JSON.stringify(this.receipt);
         console.log(params);
         this.$store.dispatch('pos/printReceipt', params)
           .then((response) => {
             console.log(response.data.status);
             if(response.data.status == 'error'){
                 if(response.data.message != null){
                   this.showErrorMsg({
                   message: "Print Failed: " + response.data.message
                 });
                 }
                 else{
                   this.showErrorMsg({
                     message: "Print Failed. Please check Print service is running."
                   });
                 }
               }
               else{
                 this.showErrorMsg({
                   message: "Receipt Printed successfully."
                 });
               }
           })
           .catch((error) => {
             if(error.response != null && error.response.data.message != null){
               this.showErrorMsg({
                 message: "Print Failed: " + error.response.data.message
               });
             }
             else{
               this.showErrorMsg({
                 message: "Print Failed. Please check Print service is running."
               });
             }



           })
     });

     },
      processPayment(params){
        console.log('Start Payment Process');
        params.customer = this.selecetdSatsangi;
        params.session =  this.$store.state.pos.userSession;
        params.systemid = this.systemid;
        let sale = {officesale: params};
        console.log(sale);
        console.log('End Payment Process');
        this.$store.dispatch('pos/createOfficeTicket', params)
         .then(response => {
           if (response.data.success == false) {
             this.showErrorMsg({
               message: response.data.error
             })
           } else {
             this.showSuccessMsg({
               message: 'Ticket Created successfully.'
             });
             this.newSale(false);
             this.printReceipt(response.data.data)

           }


         })
         .catch(error => {
           if (error.response.status == 400) {
             this.showErrorMsg({
               message: error.response.data.message
             })
           }
           else if (error.response.status == 422){
               this.showErrorMsg({
                 message: error.response.data.message
               });

           }
           else {
             this.showErrorMsg({message: "Something went wrong when fetching Bhaint and Prasad categories. Please contact administrator."})
           }
         });

      },
      parkSale() {
        this.$refs.ticketItemsTab.parkSale()
        this.$refs.ticketItemsTab.setBarcodeInputFocus()
      },
      retrieveParkedSale() {
        this.$refs.ticketItemsTab.retrieveParkedSale()
        this.$refs.ticketItemsTab.setBarcodeInputFocus()
      },
      setFocus() {
        this.$refs.ticketItemsTab.setBarcodeInputFocus()
      },
      searchSatsangi() {
        if (!this.checkBhentTrasactionExists()) {
          this.$refs.modalSearchSatsangi.show()
        }
      },
      checkBhentTrasactionExists() {
        var returnValue = false
        const selectedProducts = this.$refs.ticketItemsTab.getProductsSelected()

        if (selectedProducts != null) {
          for (let i = 0; i < selectedProducts.length; i++) {
            var line = selectedProducts[i]
            if (this.checkBhentOrPrasadCategory(line.categoryId, true)) {
              returnValue = true
              this.showErrorMsg({
                message:
                  'Please remove Bhaint transactions before removing/changing the Satsangi card. (सत्संगी का कॉर्ड चेंज करने से पहले, कृपया पहले भेंट ट्रेन्ज़ेक्शन को डिलीट करें).'
              })
              break
            }
          }
        }

        return returnValue
      },
      searchSatsangiSuccess(foundSatsangi) {
        this.selecetdSatsangi = foundSatsangi
        console.log(this.selecetdSatsangi)
        this.$refs.modalSearchSatsangi.hide()
        this.setFocus()
      },
      cancelSearchSatsangi() {
        this.$refs.modalSearchSatsangi.hide()
        this.setFocus()
      },
      hideSearchSatsangiModal() {
        this.setFocus()
      }
    },
    mounted: function() {
      this.$refs.ticketItemsTab.setBarcodeInputFocus()
    },
    created: function(){
      if (this.$store.state.pos.bhaintPrasadCategories.length == 0) {
        let params = {
          systemid: this.systemid
        }
        this.$store.dispatch('pos/getBhainPrasadCategories', params)
        .catch(error => {

          if (error.response.status == 400) {
            this.showErrorMsg({
              message: error.response.data.message
            })
          }
          else if (error.response.status == 422){
              this.showErrorMsg({
                message: error.response.data.message
              });

          }
          else {
            this.showErrorMsg({message: "Something went wrong when fetching Bhaint and Prasad categories. Please contact administrator."})
          }
        });
      }
      if (this.$store.state.pos.userSession == null || this.$store.state.pos.userSession.length == 0) {
        let params = {
          systemid: this.systemid
        }
        this.$store.dispatch('pos/createUserSession', params)
        .catch(error => {
            console.log('Error While creating Session');
            console.log(error);
            console.log('Finish Logs for Session Creation Error');
        });
      }
    }
  }

</script>
